



















































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { Employee, IEmployee, EmployeeNode } from '@/models';

import EmployeeDetailProfileFormDialog from '../EmployeeDetailProfileFormDialog.vue';

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    employeeDetailProfileFormDialog: InstanceType<
      typeof EmployeeDetailProfileFormDialog
    >;
  };
}

export default Vue.extend<Options>({ functional: false }).extend({
  name: 'EmployeeChartNode',

  components: { EmployeeDetailProfileFormDialog },

  props: {
    node: {
      type: [Object] as PropType<EmployeeNode>
    }
  },

  computed: {
    ...mapGetters({
      getEmployeeById: 'employee/getEmployeeById'
    }),

    nodeValue(): IEmployee {
      return this.node.value;
    },

    hasChildren(): boolean {
      return this.children.length > 0;
    },

    children(): EmployeeNode[] {
      return this.node.children;
    }
  },

  methods: {
    ...mapActions({
      fetchEmployee: 'employee/fetchEmployee'
    }),

    async tryGetOrFetchEmployee(employeeId: number): Promise<Employee> {
      if (!this.getEmployeeById(employeeId)) {
        await this.fetchEmployee(employeeId);
      }
      return this.getEmployeeById(employeeId);
    },

    async openEmployeeDialog(employeeId: number) {
      const employee = await this.tryGetOrFetchEmployee(employeeId);

      this.$refs.employeeDetailProfileFormDialog.open(employee);
    }
  }
});
